export const INTERACTIVE_SHELL_GIT_AUTHOR_NAME_STORAGE_KEY = 'interactive-git-author-name';
export const INTERACTIVE_SHELL_GIT_AUTHOR_EMAIL_STORAGE_KEY = 'interactive-git-author-email';
export const INTERACTIVE_SHELL_GIT_CORS_PROXY_STORAGE_KEY = 'interactive-git-cors-proxy';
const INTERACTIVE_SHELL_GIT_CORS_PROXY_CONFIGURED_STORAGE_KEY = 'interactive-git-cors-proxy-r31-configured';

export const DEFAULT_INTERACTIVE_SHELL_GIT_CORS_PROXY = 'https://cors.isomorphic-git.org';

export type BrowserGitSettings = {
  authorName: string;
  authorEmail: string;
  corsProxy: string;
};

function readLocalStorage(key: string): string | undefined {
  try {
    if (typeof globalThis.localStorage === 'undefined') return undefined;
    return globalThis.localStorage.getItem(key) ?? undefined;
  } catch {
    return undefined;
  }
}

function readBrowserGitCorsProxy(): string {
  const stored = readLocalStorage(INTERACTIVE_SHELL_GIT_CORS_PROXY_STORAGE_KEY);
  const explicitlyConfigured =
    readLocalStorage(INTERACTIVE_SHELL_GIT_CORS_PROXY_CONFIGURED_STORAGE_KEY) === '1';
  if (explicitlyConfigured) return stored?.trim() ?? '';

  // Before R31 the Git panel persisted its old empty default as soon as it was
  // opened. Treat that legacy empty value as "unset" so existing users receive
  // the new default. Preserve an existing non-empty custom proxy.
  return stored?.trim() || DEFAULT_INTERACTIVE_SHELL_GIT_CORS_PROXY;
}

export function writeBrowserGitCorsProxySetting(value: string): void {
  try {
    if (typeof globalThis.localStorage === 'undefined') return;
    globalThis.localStorage.setItem(INTERACTIVE_SHELL_GIT_CORS_PROXY_STORAGE_KEY, value);
    globalThis.localStorage.setItem(INTERACTIVE_SHELL_GIT_CORS_PROXY_CONFIGURED_STORAGE_KEY, '1');
  } catch {
    // Browser privacy/storage policies may make local settings unavailable.
  }
}

export function readBrowserGitSettings(): BrowserGitSettings {
  return {
    authorName: readLocalStorage(INTERACTIVE_SHELL_GIT_AUTHOR_NAME_STORAGE_KEY)?.trim() ?? '',
    authorEmail: readLocalStorage(INTERACTIVE_SHELL_GIT_AUTHOR_EMAIL_STORAGE_KEY)?.trim() ?? '',
    corsProxy: readBrowserGitCorsProxy(),
  };
}

export function isDefaultPublicGitCorsProxy(value: string): boolean {
  return value.trim().replace(/\/+$/u, '') === DEFAULT_INTERACTIVE_SHELL_GIT_CORS_PROXY;
}
